import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FloatingContact from "@/components/feature/FloatingContact";
import Hero from "@/pages/home/components/Hero";
import TrustBar from "@/pages/home/components/TrustBar";
import WhyUs from "@/pages/home/components/WhyUs";
import Services from "@/pages/home/components/Services";
import Testimonials from "@/pages/home/components/Testimonials";
import Faq from "@/pages/home/components/Faq";
import Contact from "@/pages/home/components/Contact";
import HomeVisitRequest from "@/pages/home/components/HomeVisitRequest";
import StructuredData from "@/pages/home/components/StructuredData";
import { BookingProvider } from "@/pages/home/components/BookingModal";

export default function Home() {
  return (
    <BookingProvider>
      <div className="w-full bg-background-50 min-h-screen flex flex-col">
        <StructuredData />
        <Navbar />
        <main className="w-full flex-1">
          <Hero />
          <TrustBar />
          <WhyUs />
          <Services />
          <Testimonials />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <FloatingContact />
        <HomeVisitRequest />
      </div>
    </BookingProvider>
  );
}